<template>
  <div>
    <div class="table__grid grid p-10">
      <div
        class="flex text-center justify-items-center justify-center items-center p-5 border border-indigo-600 w-32 h-36 rounded-lg text-sm font-semibold"
      >
        Group of biases
      </div>
      <div
        class="flex text-center  justify-items-center justify-center items-center p-5 border border-indigo-600 w-32 h-36 rounded-lg text-sm font-semibold"
      >
        Bias
      </div>
      <div
        class="flex text-center justify-items-center justify-center items-center p-5 border border-indigo-600 w-32 h-36 rounded-lg text-sm font-semibold"
      >
        Marketing Topic
      </div>
      <div class="col-start-1 row-start-2 row-end-5 border-b-2 pb-5 border-gray-400">
        <div
          class="text-sm font-semibold rounded-xl w-48 p-3 mt-5 bg-gradient-to-r from-white to-indigo-300"
        >
          Non-standard preferences
        </div>
      </div>
      <div class="text-sm py-2 my-2 col-start-2 row-start-2 row-end-3">
        Time-inconsistent preferences
      </div>
      <div class="py-2 my-2 col-start-3 row-start-2 row-end-3">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[0]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="text-sm py-2 my-2 col-start-2 row-start-3 row-end-4">
        Reference dependence
      </div>
      <div class="py-2 my-2 col-start-3 row-start-3 row-end-4">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[1]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div
        class="text-sm py-2 pb-5 col-start-2 row-start-4 row-end-5 border-b-2 border-gray-400"
      >
        Social preferences
      </div>
      <div
        class="py-2 pb-5 col-start-3 row-start-4 row-end-5 border-b-2 border-gray-400"
      >
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[2]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="col-start-1 row-start-5 row-end-7 border-b-2 border-gray-400">
        <div
          class="text-sm font-semibold rounded-xl w-48 p-3 mt-5 bg-gradient-to-r from-white to-indigo-300"
        >
          Non-standard beliefs
        </div>
      </div>
      <div class="text-sm pt-5 my-2 col-start-2 row-start-5 row-end-6 pt-4">
        Overconfidence
      </div>
      <div class="pt-5 pb-5 my-2 col-start-3 row-start-5 row-end-6">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[3]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div
        class="text-sm py-2 col-start-2 row-start-6 row-end-7 border-b-2 border-gray-400"
      >
        Projection Bias
      </div>
      <div
        class="pb-5 col-start-3 row-start-6 row-end-7 border-b-2 border-gray-400"
      >
        <ul class="list-disc">
         <li class="text-xs py-1" v-for="(item,index) in info[4]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="text-sm pt-5 my-2 col-start-2 row-start-7 row-end-8">
        Law of small numbers
      </div>
      <div class="pt-5 my-2 col-start-3 row-start-7 row-end-8">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[5]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="col-start-1 row-start-7 row-end-9">
        <div
          class="text-sm font-semibold rounded-xl w-48 p-3 mt-5 bg-gradient-to-r from-white to-indigo-300"
        >
          Non-standard decision making
        </div>
      </div>
      <div class="text-sm py-2 my-2 col-start-2 row-start-8 row-end-9">
        Choice architecture/Framing
      </div>
      <div class="py-2 my-2 col-start-3 row-start-8 row-end-9">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[6]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="text-sm py-2 my-2 col-start-2 row-start-9 row-end-10">
        Limited attention
      </div>
      <div class="py-2 my-2 col-start-3 row-start-9 row-end-10">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[7]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="text-sm py-2 my-2 col-start-2 row-start-10 row-end-11">
        Persuasion and social pressure
      </div>
      <div class="py-2 my-2 col-start-3 row-start-10 row-end-11">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[8]" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="text-sm py-2 my-2 col-start-2 row-start-11 row-end-12">
        Emotions
      </div>
      <div class="pb-5 my-2 col-start-3 row-start-11 row-end-12">
        <ul class="list-disc">
          <li class="text-xs py-1" v-for="(item,index) in info[9]" :key="index">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Array
  },
};
</script>

<style></style>
